import rule from './event/store';
import reportTemplate from './reportTemplate/store';
import forms from '../../../cmms/forms/store';
import masterData from '../../../cmms/masterData/store';
import systemManagement from '../../../cmms/systemManagement/store';

export default {
  namespaced: true,
  modules: {
    rule,
    reportTemplate,
    forms,
    masterData,
    systemManagement,
  },
};
